import * as React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
} from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import type { POLICYCONFIGURATORSECTIONS } from '../shared/Utilities/PolicyConfiguratorInterfaces';

interface IUpsertRuleConfirmationDialogProps {
  showModal: boolean,
  setShowModal: (value: boolean) => void,
  clearForm: () => void,
  isEdit: boolean,
  policyConfiguratorSection: POLICYCONFIGURATORSECTIONS,
  workflowName: string;
  companyName: string | null;
}

const UpsertRuleConfirmationDialog: React.FC<IUpsertRuleConfirmationDialogProps> = ({
  showModal,
  setShowModal,
  clearForm,
  isEdit,
  policyConfiguratorSection,
  workflowName,
  companyName,
}) => {
  const navigate = useNavigate();

  const createNewUrl = `/create-${policyConfiguratorSection.replace(/\s/g, '')}-rule`;
  const viewAllUrl = `/${policyConfiguratorSection.replace(/\s/g, '')}-rules/?workflow=${workflowName}${companyName ? `&company=${companyName}` : ''}`;

  return (
    <Dialog
      onClose={() => {}}
      open={showModal}
      fullWidth
      maxWidth="md"
      disableEnforceFocus
      disableRestoreFocus
    >
      <DialogTitle disableTypography>
        <Typography variant="overline">
          {`${workflowName} Rule ${isEdit ? 'Edited' : 'Created'}`}
        </Typography>
        <Typography variant="h5" id="dialog-header">
          {`Your ${policyConfiguratorSection} rule has been successfully ${isEdit ? 'updated' : 'created'}.`}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box my={-1}>
          <Typography variant="body2" color="textSecondary">
            {`Do you want to create a new ${policyConfiguratorSection} rule?`}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button color="primary" variant="text" onClick={() => navigate(viewAllUrl)}>
          {`NO, VIEW ALL ${policyConfiguratorSection.toUpperCase()} RULES`}
        </Button>
        <Button color="primary" variant="contained" onClick={() => { setShowModal(false); navigate(createNewUrl); }}>
          {'YES, CLONE RULE'}
        </Button>
        <Button color="primary" variant="contained" onClick={() => { setShowModal(false); clearForm(); navigate(createNewUrl); }}>
          {'YES, CREATE NEW'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpsertRuleConfirmationDialog;
